<template>
  <div class="h-100">
    <div v-if="isLoaded">
      <div class="mb-4">
        <a :href="`/${$t('trainingsUrl')}/`" class="btn btn-primary btn-icon">
          <span class="icon icon-plus"></span>
          {{ $t('orderNewFormation') }}
        </a>
      </div>
      <div v-if="orders.length">
        <h3 class="mb-4">
          {{ $t('orderHistory') }}
        </h3>

        <div v-for="(item, indexSession) in orders" :key="indexSession">
          <div
            v-for="(orderItem, indexOrderItem) in item.orderItems.data"
            :key="indexOrderItem"
            class="order-training"
          >
            <div class="order-training__main">
              <div>
                <div class="order-training__sup">
                  {{ $t('session') }} # {{ getSessioneRef(orderItem) }}
                </div>
                <div class="order-training__title">
                  {{ getCourseName(orderItem) }}
                </div>
                <div class="link-icon">
                  <span class="icon icon-date"></span
                  >{{ getSessionDate(orderItem) }}
                </div>
                <div class="link-icon">
                  <span class="icon icon-baloon"></span
                  >{{ getLocation(orderItem) }}
                </div>
              </div>
              <div class="order-training__price icon-price">
                {{ getQty(orderItem) }}
                <div class="icon icon_xs icon-cross mx-1"></div>
                {{ getAmount(orderItem) }} €
              </div>

              <div class="order-training__price icon-price">
                {{ getTotal(orderItem) }} €
              </div>

              <div
                class="order-training__btn"
                data-toggle="collapse"
                :data-target="'#training-' + orderItem.id"
                aria-expanded="false"
                :aria-controls="'training-' + orderItem.id"
              ></div>
            </div>
            <div class="order-training__dates" :id="'training-' + orderItem.id">
              <h4 class="mt-3">{{ $t('trainees') }}</h4>
              <div class="dates dates_users">
                <div
                  v-for="(trainee, index) in getTrainees(orderItem)"
                  :key="index"
                  class="dates__line"
                >
                  <div class="dates__row">
                    <div>{{ trainee.trainee_name }}</div>
                    <div>{{ trainee.birthday }}</div>
                    <div>{{ trainee.trainee_email }}</div>
                  </div>
                  <div class="dates__btn">
                    <a
                      :href="trainee.linkFollowUpCertificate || '#'"
                      class="btn btn-icon btn-primary w-100"
                      download
                      target="_blank"
                      :class="{
                        disabled: !trainee.linkFollowUpCertificate,
                      }"
                    >
                      <span class="icon icon-file_white"></span>
                      {{ $t('buttons.attestationButton') }}
                    </a>
                  </div>
                  <div class="dates__btn">
                    <a
                      :href="certificate"
                      :class="{
                        'disabled ': !hasCertificate(trainee, index, orderItem),
                      }"
                      class="btn btn-icon btn-primary w-100"
                      @click="getCertificate(trainee, orderItem)"
                      role="button"
                    >
                      <span class="icon icon-file_white"></span>
                      {{ $t('buttons.certificateButton') }}
                    </a>
                  </div>
                </div>
              </div>
              <h4 class="mt-3">{{ $t('documents') }}</h4>
              <div class="link-icon">
                <div class="dates__btn"  v-if="getConventionUrl(item)">
                  <a
                    :href="getConventionUrl(item)"
                    class="btn btn-icon btn-primary w-100"
                  >
                    <span class="icon icon-file_white"></span>
                    {{ $t('buttons.opcoFolderButton') }}
                  </a>
                </div>
                <div class="dates__btn" v-if="getConvocationUrl(item)">
                  <a
                    :href="getConvocationUrl(item)"
                    class="btn btn-icon btn-primary w-100"
                  >
                    <span class="icon icon-file_white"></span>
                    {{ $t('buttons.convocationButton') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="box-block text-center">
          <div class="alert alert-primary mb-0">
            {{ $t('emptySessionList') }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h-100">
      <div class="h-100 row d-flex justify-content-center align-items-center">
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
export default {
  name: 'MySessions',
  data() {
    return {
      isLoaded: false,
      certificate: '',
      atesstation: '',
      dossierOpco: '#',
      orders: [],
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
    ...mapGetters(['vatRate']),
  },
  mounted() {
    this.getTraineesResults()
  },
  methods: {
    getTraineesResults() {
      this.$store.dispatch('getUserOrders').then((data) => {
        this.orders = data
        this.isLoaded = true
        window.scrollTo(0, 0)
      }).finally(()=> {
        this.isLoaded = true
      })
    },
    hasCertificate(trainee, indexTrainee, orderItem) {
      let index = this.$lodash.findIndex(
        this.user.trainees.data,
        (t) => t.id == trainee.trainee_id
      )
      if (index == -1) return false
      let userTrainee = this.user.trainees.data[index]
      let results = this.$lodash.get(userTrainee, 'results.data', [])
      let sessionResult = results.find(
        (r) => r.sessionId == orderItem.sessionId
      )
      if (sessionResult) {
        return sessionResult.resultStatus
      } else return false
    },
    hasAttestation(trainee, indexTrainee, orderItem) {
      let index = this.$lodash.findIndex(
        this.user.trainees.data,
        (t) => t.id == trainee.trainee_id
      )
      if (index == -1) return false
      let userTrainee = this.user.trainees.data[index]
      let results = this.$lodash.get(userTrainee, 'results.data', [])
      let sessionCompleted = results.find(
        (r) => r.sessionId == orderItem.sessionId
      )
      if (sessionCompleted) {
        return sessionCompleted.completed
      } else return false
    },
    getAtesstations(trainee, orderItem) {
      let local = document.head.querySelector('meta[name="app-locale"]').content
      let traineeId = this.$lodash.get(trainee, 'trainee_id', '')
      let sessionId = this.$lodash.get(orderItem, 'sessionId', '')
      let linkCertif = this.$lodash.get(
        orderItem,
        'linkFollowUpCertificate',
        ''
      )
      let id = this.$lodash.get(this.user, 'id', false)
      if (id)
        return (this.atesstation =
          linkCertif +
          '/' +
          id +
          '?traineeId=' +
          traineeId +
          '&sessionId=' +
          sessionId +
          '&lang=' +
          local)
      else return false
    },
    getConvocationUrl(session) {
      return session?.orderItems?.data?.[0]?.linkConvocation ?? false
    },
    getConventionUrl(session) {
      return session?.orderItems?.data?.[0]?.linkConvention ?? false
    },
    getCertificate(trainee, orderItem) {
      let traineeId = this.$lodash.get(trainee, 'trainee_id', '')
      let linkCertif = this.$lodash.get(orderItem, 'linkCertificate', '')
      let sessionId = this.$lodash.get(orderItem, 'sessionId', '')
      return (this.certificate =
        linkCertif + '?traineeId=' + traineeId + '&sessionId=' + sessionId)
    },
    getTrainees(orderItem) {
      let trainees = this.$lodash.get(orderItem, 'trainees', [])
      return trainees
    },

    getSessionDate(orderItem) {
      let sessioneDate = this.$lodash.get(orderItem, 'dateSession', '')
      return sessioneDate
    },
    getSessioneRef(orderItem) {
      let sessioneRef = this.$lodash.get(orderItem, 'courseRef', '')
      return sessioneRef
    },
    getCourseName(orderItem) {
      let sessionName = this.$lodash.get(orderItem, 'courseName', '')
      return sessionName
    },
    getLocation(orderItem) {
      let sessionlocation = this.$lodash.get(orderItem, 'location', '')
      return sessionlocation
    },
    getQty(orderItem) {
      let qte = this.$lodash.get(orderItem, 'qte', 0)
      return qte
    },
    getAmount(orderItem) {
      let price = this.$lodash.get(orderItem, 'price', 0)
      return price
    },
    getTotal(orderItem) {
      let qte = this.$lodash.get(orderItem, 'qte', 0)
      let price = this.$lodash.get(orderItem, 'price', 0)
      let amount = parseFloat(price) * parseInt(qte)
      let totalPrice = parseFloat(amount) * parseFloat(this.vatRate)
      return totalPrice + amount
    },
  },
}
</script>

<style></style>
